import React, { useState, useEffect } from "react";
import Axios from "../../_services/caller.service";
import styles from "./UpcomingCalibrationsChart.module.scss";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const UpcomingCalibrationsChart = () => {
  const { t } = useTranslation();
  const [calibrations, setCalibrations] = useState([]);
  const [error, setError] = useState(null);
  const [minDays, setMinDays] = useState(-360);
  const [maxDays, setMaxDays] = useState(30);
  const [selectedTransducer, setSelectedTransducer] = useState("All");
  const [selectedPeriod, setSelectedPeriod] = useState("1month");

  const transducerNames = {
    Speakers: t("calibration.free_field"),
    Headphones: t("calibration.headphones"),
    Inserts: t("calibration.inserts"),
    Bone: t("calibration.bone_conduction"),
  };

  const periodOptions = {
    "1week": 7,
    "2weeks": 14,
    "1month": 30,
    "3months": 90,
    "6months": 180,
  };

  useEffect(() => {
    fetchCalibrations();
  }, []);

  const fetchCalibrations = async () => {
    setError(null);
    try {
      const response = await Axios.get(
        `/getUpcomingCalibrations?minDays=${minDays}&maxDays=${maxDays}`
      );
      setCalibrations(response.data.data);
    } catch (err) {
      console.error("Erreur lors de la récupération des calibrations :", err.message);
      setError(t("calibration.error_loading_config"));
    }
  };

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setSelectedPeriod(period);
    setMaxDays(periodOptions[period]);
  };

  const handleTransducerChange = (e) => setSelectedTransducer(e.target.value);

  const filteredData = calibrations.filter((calibration) =>
    selectedTransducer === "All" || calibration.Eoutpout === selectedTransducer
  );

  const calibrationCounts = filteredData.reduce((acc, calibration) => {
    const type = transducerNames[calibration.Eoutpout] || calibration.Eoutpout;
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(calibrationCounts).map(([key, value]) => ({
    name: key,
    count: value,
  }));

  return (
    <div className={styles.container}>
      <h3>{t("calibration.upcoming_count_title")}</h3>
      
      <div className={styles.filters}>
        <select value={selectedPeriod} onChange={handlePeriodChange} className={styles.select}>
          <option value="1week">{t("calibration.1_week")}</option>
          <option value="2weeks">{t("calibration.2_weeks")}</option>
          <option value="1month">{t("calibration.1_month")}</option>
          <option value="3months">{t("calibration.3_months")}</option>
          <option value="6months">{t("calibration.6_months")}</option>
        </select>
        <select value={selectedTransducer} onChange={handleTransducerChange} className={styles.select}>
          <option value="All">{t("common.all")}</option>
          {Object.entries(transducerNames).map(([key, name]) => (
            <option key={key} value={key}>{name}</option>
          ))}
        </select>
        <button type="button" onClick={fetchCalibrations} className={styles.fetchButton}>{t("common.filter")}</button>
      </div>
      
      {error && <p className={styles.error}>{error}</p>}

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#134a6d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UpcomingCalibrationsChart;
